import Phaser from 'phaser';
import { Player } from '../../classes/Player';
import { Portal } from 'src/classes/Portal';
import VirtualJoyStick from 'phaser3-rex-plugins/plugins/virtualjoystick';
import { Character } from 'src/classes/Character';
import BaseLevelScene from './BaseLevelScene';

export default class RestInPiecesScene extends BaseLevelScene {
  tileWidth: integer = 32;
  tileHeight: integer = 32;
  exits: Portal[] = [];
  expandedMaze: Array<Array<integer>>;
  player: Player;
  joystick: VirtualJoyStick;
  map: Phaser.Tilemaps.Tilemap;

  constructor() {
    super('Rest in Pieces');
  }

  preload() {

    // preload base level
    this.preloadBaseLevel();

    // load the PNG file
    this.load.image('rip_tiles', 'assets/sourceImages/interior.png');

    // load the JSON file
    this.load.tilemapTiledJSON(
      'rip_tilemap',
      'assets/scenes/rip_interior.json'
    );

    // Load character data
    Character.preload(this);

    // Load portal assets
    Portal.preload(this);
  }

  create() {
    // 👌 sanity check by displaying the entire tileset image
    // this.add.image(0, 0, 'rip_tiles');

    // create the Tilemap
    this.map = this.make.tilemap({ key: 'rip_tilemap' });

    // add the tileset image we are using
    const tileset = this.map.addTilesetImage('building.tsj', 'rip_tiles');

    // create the layers we want in the right order
    const floor = this.map.createLayer('floor', tileset);
    this.matter.world.convertTilemapLayer(floor);

    // "Ground" layer will be on top of "Background" layer
    const walls = this.map.createLayer('walls', tileset);
    walls.setCollisionByExclusion([-1]);
    this.matter.world.convertTilemapLayer(walls);

    // "Ground" layer will be on top of "Background" layer
    const furniture = this.map.createLayer('furniture', tileset);
    furniture.setCollisionByExclusion([-1]);
    this.matter.world.convertTilemapLayer(furniture);

    // "Ground" layer will be on top of "Background" layer
    const stuff = this.map.createLayer('stuff', tileset);
    stuff.setCollisionByExclusion([-1]);
    this.matter.world.convertTilemapLayer(stuff);


    // create base level
    this.createBaseLevel();
  }
}
